<template>
<div :id="id" class="window window-setting window-bg" status="false" @click.self.stop="hide">
	<div class="body bgContent">
		<Loading ref="Loading"></Loading>
		<div class="head bgContent">
			<div class="tool">
				<slot name="headButton"></slot>
				<button class="close bgClose fSub hover-f-error" :title="$t('cmd153',['关闭'])" type="button" @click.stop="hide"><Icon name="close" class="w1x h1x close-ico" :sizeBase="'m'" /></button>
			</div>
			<div class="title">{{title}}</div>
			<slot name="head"></slot>
		</div>
		<div class="mt1x pl1x pr1x" fillHeight="lastHeight" scroll>
			<slot></slot>
		</div>
		<div class="toolBar taR vaM_E"><!--borderToken_E ml1x_E mr1x_E dpIB_E w7x_E-->
			<button v-if="footerButton" class="bdSub hover-bg-highLight" :title="$t('cmd85',['取消'])" @click="hide" type="button">{{$t('cmd85',['取消'])}}</button>
			<button v-if="footerButton" class="functionBtn" @click="save" :title="$t('cmd84',['保存'])" type="button">{{$t('cmd84',['保存'])}}</button>
			<slot name="footerButton"></slot>
		</div>
	</div>
</div>
</template>
<script>
import Loading from '@/components/common/ui/Loading'
import * as lib from "@/util/lib.js";
import {getLanguageStr} from "@/util/language.js";

export default {
	name:'WindowForSetting',
	props:{
		id:{//指定dom的id
			type:Number,
			default:null
		},
		title:{
			type:String,
			default:""
		},
		footerButton:{//默认下是页脚按钮
			type:Boolean,
			default:true
		}
	},
	components:{Loading},
	created(){
	},
	data(){
		return {
			option:{
			},
		}
	},
	methods:{
		getLanguageStr,
		// outClickToHide(e){
		// 	if(e){
		// 		this.hide();
		// 	}
		// },
		loadStatusAction:function(action){
			if(action) this.$refs.Loading.show();
			else this.$refs.Loading.hide();
		},
		show:function(option){
			// if(option){
			// 	if(option.bg!=undefined) this.option.bg=option.bg;
			// }
			lib.windowCtrl($(this.$el),"true");
			if(option){
				if(option.end){
					setTimeout(option.end,500);
				}
			}
			// $(window).off("click",this.outClickToHide);
			// $(window).on("click",this.outClickToHide);
		},
		hide:function(){
			// $(window).off("click",this.outClickToHide);
			this.$emit('Close');
			lib.windowCtrl($(this.$el),"false",{end:()=>{
				this.$emit('Closed');
			}});
		},
		save:function(){
			this.$emit("Save");
		}
	},
	watch:{
	},
	mounted(){
	}
}
</script>
<style lang="scss" scoped>
.body{width:40%;padding:{bottom:0;};border-radius:0;top:0;bottom:0;right:0;transform:rotateX(0) translateZ(0) translateX(100%);
	.head{padding:{left:1em;};cursor:auto;color:$fontContentColor;
		>*{height:unset;}
		.title{font-size:1.4em;text-align:left;}
	}
}
.tool{position:absolute;right:1em;}
.window-setting{z-index:21;
	.toolBar{margin:{bottom:0;};padding:{bottom:1em;};position:fixed;bottom:0;right:0;
		button{margin:{left:0;};}
	}
}
</style>




// WEBPACK FOOTER //
// src/components/common/ui/WindowForSetting.vue